import { useDispatch } from 'react-redux'
import { ArrowUturnLeftIcon } from '@heroicons/react/20/solid'
import { resetGroupIndividualOverrideInputs } from 'redux/slices/activeWorkout'
import { useGetExercises } from 'redux/customHooks/useGetExercises'

import UserProfilePicture from 'components/User/UserProfilePicture'
import VolumeCompleted from 'components/ActiveWorkout/VolumeCompleted'
import LoadCompleted from 'components/ActiveWorkout/LoadCompleted'
// import DifficultyScale from 'components/ActiveWorkout/DifficultyScale'
import ActionButtons from 'components/ActiveWorkout/ActionButtons'

export default function GroupIndividualExerciseSetListItem({ 
    version = '4.0',
    profileType,
    groupId,
    athleteId,
    athleteFirstName,
    athleteLastName,
    groupIndividualOverrideInputs,
    workoutType,
    taperData,
    phaseIndex, 
    exerciseIndex, 
    exercise, 
    setIndex, 
    set
}) {
    const dispatch = useDispatch()

    const { exercises } = useGetExercises()

    const ResetGroupIndividualOverrideInputs = () => {
        const payload = {
            profileType: profileType,
            groupId: groupId,
            athleteId: athleteId,
            phaseIndex: phaseIndex,
            exerciseIndex: exerciseIndex,
            setIndex: setIndex
        }

        // console.log(payload)

        dispatch(resetGroupIndividualOverrideInputs(payload))
    }

    const isCompleted = set.groupIndividualCompletedSetData[athleteId].completed
    const isSkipped = set.groupIndividualCompletedSetData[athleteId].skipped
    const isRecommendation = exercise.exerciseType === 'recommendation'

    if (exercises.length === 0) { 
        return (
            <div className='w-full h-32 p-4'>
                <div className='w-full h-full bg-gray-200 rounded-lg animate-pulse' />
            </div>
        )
    }

    return (
        <div className='w-full p-4 flex items-center gap-x-4'>
            <div className='flex items-center gap-x-2'>
                <div className='w-20 h-20 p-2'>
                    <UserProfilePicture 
                        firstName={athleteFirstName} 
                        lastName={athleteLastName} 
                        size='large'
                        shadow={false} 
                    />
                </div>

                <p className='w-[175px] text-lg truncate'>{athleteFirstName} {athleteLastName}</p>
            </div>

            <div className='flex-1' />

            {isSkipped === false && (
                <>
                    <LoadCompleted
                        profileType={profileType}
                        groupId={groupId}
                        athleteId={athleteId}
                        phaseIndex={phaseIndex}
                        exerciseIndex={exerciseIndex}
                        exercise={exercise}
                        setIndex={setIndex}
                        set={set}
                        isRecommendation={isRecommendation}
                        isCompleted={isCompleted}
                        isSkipped={isSkipped}
                        showLabel={false}
                    /> 

                    <VolumeCompleted
                        version={version}
                        profileType={profileType}
                        groupId={groupId}
                        athleteId={athleteId}
                        phaseIndex={phaseIndex}
                        exerciseIndex={exerciseIndex}
                        exercise={exercise}
                        setIndex={setIndex}
                        set={set}
                        isCompleted={isCompleted}
                        isSkipped={isSkipped}
                        showLabel={false}
                    />

                    {/* 
                    <DifficultyScale
                        profileType={profileType}
                        groupId={groupId}
                        athleteId={athleteId}
                        phaseIndex={phaseIndex}
                        exerciseIndex={exerciseIndex}
                        exercise={exercise}
                        setIndex={setIndex}
                        set={set}
                        isCompleted={isCompleted}
                        isSkipped={isSkipped}
                        showLabel={false}
                    /> 
                    */}
                </>
            )}

            <ActionButtons
                version={version}
                profileType={profileType}
                groupId={groupId}
                athleteId={athleteId}
                taperData={taperData}
                workoutType={workoutType}
                phaseIndex={phaseIndex}
                exerciseIndex={exerciseIndex}
                exercise={exercise}
                setIndex={setIndex}
                set={set}
                isCompleted={isCompleted}
                isSkipped={isSkipped}
                isRecommendation={isRecommendation}
                showLabel={false}
            />

            {!groupIndividualOverrideInputs && (
                <div className='w-[28px]' />
            )}

            {groupIndividualOverrideInputs && (
                <div 
                    className='w-[28px]'
                    onClick={ResetGroupIndividualOverrideInputs}
                >
                    <ArrowUturnLeftIcon className='w-8 h-8 text-gray-600' />
                </div>
            )}
        </div>
    )
}